import { render, staticRenderFns } from "./historicalSalary.vue?vue&type=template&id=24052cce&scoped=true&"
import script from "./historicalSalary.vue?vue&type=script&lang=js&"
export * from "./historicalSalary.vue?vue&type=script&lang=js&"
import style0 from "./historicalSalary.vue?vue&type=style&index=0&id=24052cce&prod&lang=scss&scoped=true&"
import style1 from "./historicalSalary.vue?vue&type=style&index=1&id=24052cce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24052cce",
  null
  
)

export default component.exports